import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { useRouter } from 'next/router';

import { CardButtonMediumTruncatedText } from '@components/cards/CardButtonMediumTruncatedText';
import { useCurrentCoverPublicationImage } from '@modules/publications/publications.store';
import { Publication } from '@modules/publications/publications.types';
import { formatPublicationDistance } from '@utils/distance';
import { formatPromotionValue } from '@utils/formatPromotionValue';

type PublicationsVirtualItemProps = {
  publication: Publication;
  href: string;
  maxWidth?: string;
  distance?: number;
};

export const PublicationVirtualItem = (props: PublicationsVirtualItemProps) => {
  const router = useRouter();
  const { publication } = props;
  const { data: publicationImage } = useCurrentCoverPublicationImage(
    publication?.id as string,
    publication?.cover_image_id as number,
  );
  const image = `${router?.basePath}/assets/image/publication-placeholder.webp`;
  const isGlobal = publication?.is_global;
  const infoLabelPrimary = isGlobal
    ? 'Disponível em todo Brasil'
    : formatPublicationDistance(publication?.distance);

  return (
    <LinkWrapper href={props.href}>
      <CardButtonMediumTruncatedText
        key={publication?.id}
        title={publication?.name as string}
        description={formatPromotionValue(publication)}
        image={publicationImage?.asset_url || image}
        maxWidth={props.maxWidth}
        infoLabelPrimary={infoLabelPrimary}
      />
    </LinkWrapper>
  );
};
